import Paginations from "components/Common/Pagination"
import IsLoading from "components/Shared/IsLoading"
import NoDataAvailable from "components/Shared/NoDataAvailable"
import Spinners from "components/Shared/Spinners"
import { usePermissions } from "hooks"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap"
import { getAssessmentList } from "store/actions/interviewsAction"

const CandidateScheduledForInterview = ({
  setGetAllData,
  filtersState,
  activeTab,
}) => {
  const {
    loading,
    assessmentsList,
    perPage,
    totalPages,
    totalCount,
    currentPage,
    otherTabPayload: payload,
  } = useSelector(state => state.Interviews)
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { showAll, permissions } = usePermissions("interview_schedule")
  const { permissions: iePermissions } = usePermissions("interview_evaluation")
  const { uuid } = useParams()
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)
  const [selectedItem, setSelectedItem] = useState({})

  useEffect(() => {
    getAllData()
  }, [activeTab, filtersState.job_title_ids])

  const getAllData = (page, isReset = false) => {
    const { searchKeyword } = filtersState

    const payload = {
      limit: 50,
      page_number: page || 1,
      order_by: 1,
      filters: {
        interview_schedule_uuid: uuid,
        status: 1,
        type: activeTab === "SCHEDULE_FOR_INTERVIEW" ? 1 : 2,
        keyword: isReset ? "" : searchKeyword,
        date_range: [],
        job_title_ids:
          activeTab === "INTERVIEW_COMPLETED"
            ? filtersState.job_title_ids || []
            : [],
      },
    }
    dispatch(getAssessmentList(payload))
  }

  setGetAllData(getAllData)

  const onPageChange = page => {
    getAllData(page)
  }

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <>
          <Card className="user_personal_info mt-3 theme_card">
            <CardBody>
              <div className="table-responsive">
                {!loading && assessmentsList?.length === 0 ? (
                  <NoDataAvailable />
                ) : (
                  <Table className="table mb-0">
                    <thead className="table-light full_th">
                      <tr>
                        <th>{t("S. No.")}</th>
                        <th>{t("Name")}</th>
                        <th>{t("National Id")}</th>
                        <th>{t("Phone")}</th>
                        <th>{t("Nationality")}</th>
                        <th>{t("Schedule Date")}</th>
                        <th>{t("Schedule Time")}</th>
                        {activeTab === "INTERVIEW_COMPLETED" && (
                          <>
                            <th>{t("Obtained Score")}</th>
                            <th>{t("Interviewed By")}</th>
                            <th>{t("Assign Job Title")}</th>
                            <th>{t("Submitted Date")}</th>
                            <th>{t("Trial Operation")}</th>
                          </>
                        )}
                        <th>{t("Action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assessmentsList?.map((item, index) => (
                        <tr key={index} className="cursor-pointer">
                          <td>{(currentPage - 1) * perPage + index + 1}</td>
                          <td>{item?.user?.name}</td>
                          <td>{item?.user?.national_id}</td>
                          <td>
                            <p className="ltr fit_content">
                              {item?.user?.phone}
                            </p>
                          </td>
                          <td>{item?.user?.nationality_name}</td>
                          <td>
                            <p className="ltr fit_content">
                              {item?.interview_schedule?.start_date}
                            </p>
                          </td>
                          <td className="fit_content">
                            <p className="ltr fit_content">
                              {item?.interview_schedule?.start_time} ~{" "}
                              {item?.interview_schedule?.end_time}
                            </p>
                          </td>
                          {activeTab === "INTERVIEW_COMPLETED" && (
                            <>
                              <td>{item?.obtained_score} </td>
                              <td>{item?.interviewer_by} </td>
                              <td>{item?.assign_job_title} </td>
                              <td>{item?.submitted_at} </td>
                              <td>
                                {item?.would_you_like_work_in_trial_period ===
                                true
                                  ? t("Yes")
                                  : t("No")}
                              </td>
                            </>
                          )}
                          <td>
                            {!item?.is_submitted &&
                              (showAll ||
                                iePermissions.includes(
                                  "can_conduct_interview"
                                )) && (
                                <div className="d-flex gap-3 ">
                                  <Button
                                    color="primary"
                                    className="fit_content"
                                    onClick={() => {
                                      toggle()
                                      setSelectedItem(item)
                                    }}
                                  >
                                    {t("Start Interview")}
                                  </Button>
                                </div>
                              )}
                            {/* SHOW VIEW BUTTON ONCE SUBMITTED */}
                            {activeTab === "INTERVIEW_COMPLETED" &&
                              item?.is_submitted &&
                              (showAll ||
                                permissions.includes("can_view_details")) && (
                                <Button
                                  color="secondary"
                                  className="fit_content"
                                  onClick={() => {
                                    window.open(
                                      `/interview-appointments/view-assessment?uuid=${item?.user?.uuid}&interviewUuid=${item?.uuid}`,
                                      "_blank"
                                    )
                                  }}
                                >
                                  {t("View Details")}
                                </Button>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            </CardBody>
          </Card>
          {!loading && assessmentsList.length > 0 && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              totalCount={totalCount}
              onPageChange={onPageChange}
            />
          )}
        </>
      )}

      <Modal
        isOpen={modal}
        toggle={toggle}
        className=""
        backdrop="static"
        centered
      >
        <ModalHeader toggle={toggle}>
          {t("This interview is being recorded")}
        </ModalHeader>
        <ModalFooter>
          <div className="my-2">
            <Button
              color="success"
              type="submit"
              onClick={() => {
                toggle()
                window.open(
                  `/interview-appointments/start-assessment?uuid=${selectedItem?.user?.uuid}&interviewUuid=${selectedItem?.uuid}`,
                  "_blank"
                )
              }}
            >
              {t("Ok")}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default CandidateScheduledForInterview
